import React, { Component } from 'react';
import { Button, Card, Col, Form, Icon, Input, Row, Switch, Cascader } from "antd";
import Basic from './Basic';


class Cupons extends Component {
  render() {
    return (
        <Basic/>
    );
  }
}


export default Cupons;


// WEBPACK FOOTER //
// ./src/routes/main/Cupons/verified/index.js